module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/408.df3d3576.png";